<div class="flex justify-content-center align-items-center h-full">
  <div
    class="p-card p-2 w-25rem h-14rem flex flex-column justify-content-center align-items-center gap-5"
  >
    <div class="text-center">
      <span class="text-base font-bold line-height-3">Selecciona una carretera</span>
    </div>
    @if (hasError) {
      <div class="text-center">
        <small class="text-red-500">{{ hasAuthorizationError ? errorAuthorizationMessage : errorMessage }}</small><br>
        <p-button label="Reintentar" class="mt-2 secondary-button" (click)="retryLoad()" />
      </div>
    } @else {
      <div class="">
        <p-dropdown
          [options]="roads"
          [(ngModel)]="selectedRoad"
          placeholder="Selecciona una carretera"
          class="dropdown-road"
          optionLabel="text"
          [emptyMessage]="'No existen carreteras configuradas vinculadas a la concesionaria de su usuario'"
          [disabled]="roads === undefined || roads === null"
        ></p-dropdown>
      </div>
      <div>
        <!-- eslint-disable -->
        <p-button
          class="primary-button w-full"
          label="Acceder"
          (click)="accessRoad()"
          [disabled]="!selectedRoad"
        />
      </div>
    }
  </div>
</div>
